import { has } from "lodash";

// registration start
// registration complete

export const trackEvent = (event: string, data?: any) => {
  console.log("trackEvent", event, data);
  if (typeof window !== "undefined") {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event,
      platform: has(window, "flutter_inappwebview") ? "app" : "web",
      ...data
    });

    if (window.plausible) {
      window.plausible(event, {
        props: {
          platform: has(window, "flutter_inappwebview") ? "app" : "web",
          ...data
        }
      })
    }

  }
};
